export type IncidentKind = 'camera' | 'network' | 'noFace';

/** État observé des flux, côté local. */
export interface MediaHealth {
  readonly videoTrack: 'live' | 'muted' | 'ended';
  /** Âge de la dernière nouvelle image de la caméra locale. */
  readonly videoFrameAgeMs: number;
  /** Depuis combien de temps aucun visage n'est détecté (0 si visage présent). */
  readonly faceMissingMs: number;
  readonly channelOpen: boolean;
  /** Âge du dernier heartbeat reçu du pair. */
  readonly heartbeatAgeMs: number;
}

export interface IncidentThresholds {
  readonly frozenVideoMs: number;
  readonly heartbeatMs: number;
  readonly noFaceMs: number;
}

export const DEFAULT_INCIDENT_THRESHOLDS: IncidentThresholds = {
  frozenVideoMs: 1000,
  heartbeatMs: 2000,
  noFaceMs: 2000,
};

/**
 * Distingue les trois pertes avant toute sanction. Ordre de priorité :
 * réseau (on ne peut plus rien dire au pair) > caméra (le visage « absent »
 * n'est alors qu'une conséquence) > visage absent (seul cas soumis au vote).
 */
export function classifyIncident(
  health: MediaHealth,
  thresholds: Partial<IncidentThresholds> = {},
): IncidentKind | null {
  const th = { ...DEFAULT_INCIDENT_THRESHOLDS, ...thresholds };
  if (!health.channelOpen || health.heartbeatAgeMs > th.heartbeatMs) return 'network';
  if (health.videoTrack !== 'live' || health.videoFrameAgeMs > th.frozenVideoMs) return 'camera';
  if (health.faceMissingMs > th.noFaceMs) return 'noFace';
  return null;
}
